export default __webpack_public_path__ + "pgnv-assets/2baa6b588f718ccb4227bbef3e744657.svg";